import React from 'react';

import imgLaptopGraphic from './assets/img-2.png';
import imgBlueBg from './assets/img-3.png';
import imgCrossIcon from './assets/img-4.png';
import imgLogoText from './assets/img-5.png';

const Section_3 = () => {
    return (
        <section id="section3" className="bg-white py-24 sm:py-32">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="flex flex-col items-center text-center">

  
                    <div className="relative w-80 h-64 mb-12">
                        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-52 h-52 z-10 filter drop-shadow-2xl">

                        
                            <img
                                src={imgLaptopGraphic}
                                alt="Laptop graphic"
                                className="absolute w-48 h-auto top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2"
                            />
                          
                            <img
                                src={imgCrossIcon}
                                alt="Red cross icon"
                                className="absolute w-16 h-auto top-4 left-0"
                            />
                        </div>

                      
                        <div className="absolute top-1/2 right-0 -translate-y-[50%] w-44 h-44 z-20 transform rotate-9">              <div className="relative w-full h-full">
                            <img
                                src={imgBlueBg}
                                alt="App logo background"
                                className="absolute inset-0 w-full h-full drop-shadow-xl"
                            />
                            <img
                                src={imgLogoText}
                                alt="Top Agent Pro logo"
                                className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-28 h-auto"
                            />
                        </div>
                        </div>

                    </div>

                  
                    <h2 className="text-4xl font-bold tracking-tight text-gray-900 sm:text-5xl">
                        No Laptop, No Problem
                    </h2>
                    <p className="mt-6 max-w-2xl text-lg leading-8 text-gray-900">
                        No Problem Top Agent Pro lives in your pocket — and works <br></br> where you do, even offline.
                    </p>
                </div>
            </div>
        </section>
    );
};

export default Section_3;